module.exports = __webpack_public_path__ + "img/slt1.190827ad.png";